var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthInsurance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#F2EFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 12C25.4404 12 26 12.5596 26 13.25V15.75C26 15.8359 25.9913 15.9199 25.9748 16.0009L30.75 16C31.4404 16 32 16.5596 32 17.25V27.75C32 28.4404 31.4404 29 30.75 29H11.25C10.5596 29 10 28.4404 10 27.75V17.25C10 16.5596 10.5596 16 11.25 16L16.0252 16.0009C16.0087 15.9199 16 15.8359 16 15.75V13.25C16 12.5596 16.5596 12 17.25 12H24.75ZM30.75 17H11.25C11.1119 17 11 17.1119 11 17.25V27.75C11 27.8881 11.1119 28 11.25 28H30.75C30.8881 28 31 27.8881 31 27.75V17.25C31 17.1119 30.8881 17 30.75 17ZM13.5 19V26H12.5V19H13.5ZM29.25 19V26H28.25V19H29.25ZM21.65 19.5L21.649 21.875H24.025V23.125H21.649L21.65 25.5H20.4L20.399 23.125H18.025V21.875H20.399L20.4 19.5H21.65ZM24.75 13H17.25C17.1119 13 17 13.1119 17 13.25V15.75C17 15.8881 17.1119 16 17.25 16H24.75C24.8881 16 25 15.8881 25 15.75V13.25C25 13.1119 24.8881 13 24.75 13Z",
    fill: "#754FFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthInsurance);
export default __webpack_public_path__ + "static/media/health-insurance.bd0d5f29ad8240daf7f0269d1da43563.svg";
export { ForwardRef as ReactComponent };